import {ApiClient, Response404Error} from "../generated/ApiClient";
import {Aborted, useFetcher} from "./useFetcher";
import {ResponseError} from "../generated";

export const useRadioDetailKey = (slug: string) => {
    return {
        queryKey: ["useRadioDetailKey",slug],
        queryFn: useFetcher(() => new ApiClient().getApiRadioDetail({ slug }, {
            credentials: "include",
            signal: Aborted().signal
        }).catch(error => {
            if (error instanceof  ResponseError && error.response.status === 401)
            {
                throw new Response404Error(error.response);
            }

            throw error;
        }))
    }
}

function  silent(err404silent: boolean, e:any) {
    if (err404silent && e instanceof  ResponseError && e.response.status === 404)
        return null;
    throw e;
}

export const useRadioDescriptionKey = (slug: string, enabled: boolean, err404silent = true) => {
    return {
        queryKey: ["useRadioDescriptionKey",slug, enabled, err404silent],
        queryFn: useFetcher(() => enabled ? new ApiClient().getApiRadioDescription({ slug },{
            credentials: "include",
            signal: Aborted().signal
        }).catch(e => silent(err404silent, e)) : Promise.resolve(null))
    }
}

export const useRadioSimilarKey = (slug: string, enabled: boolean, err404silent = true) => {
    return {
        queryKey: ["useRadioSimilarKey",slug, enabled, err404silent],
        queryFn: useFetcher(() => enabled ? new ApiClient().getApiRadioSimilars({ slug },{
            credentials: "include",
            signal: Aborted().signal
        }).catch(e => silent(err404silent, e)): Promise.resolve(null))
    }
}

export const useRadioSongLastHourKey = (slug: string, enabled: boolean, err404silent = true) => {
    return {
        queryKey: ["useRadioSongLastHourKey", slug, enabled, err404silent, "songs"],
        queryFn: useFetcher(() => enabled ? new ApiClient().getApiRadioSongLastHour({ slug },{
            credentials: "include",
            signal: Aborted().signal
        }).catch(e => silent(err404silent, e)): Promise.resolve(null))
    }
}


export const useRadioSongProgramKey = (slug: string, enabled: boolean, err404silent = true) => {
    return {
        queryKey: ["useRadioSongProgramKey",slug, enabled, err404silent],
        queryFn: useFetcher(() => enabled ? new ApiClient().getApiRadioSongFutureProgram({ slug },{
            credentials: "include"
        }).catch(e => silent(err404silent, e)): Promise.resolve(null))
    }
}



export const useRadioPodcastProgramsKey = (slug: string, enabled: boolean, err404silent = true) => {
    return {
        queryKey: ["useRadioPodcastPrograms",slug, enabled, err404silent],
        queryFn: useFetcher(() => enabled ? new ApiClient().getApiRadioPodcastPrograms({ slug },{
            credentials: "include",
            signal: Aborted().signal
        }).catch(e => silent(err404silent, e)): Promise.resolve(null))
    }
}

export const useRadioPodcastNewestEpisodeKey = (slug: string, enabled: boolean, err404silent = true) => {
    return {
        queryKey: ["useRadioPodcastProgramKey",slug, enabled, err404silent],
        queryFn: useFetcher(() => enabled ? new ApiClient().getApiRadioPodcastNewestEpisode({ slug },{
            credentials: "include",
            signal: Aborted().signal
        }).catch(e => silent(err404silent, e)): Promise.resolve(null))
    }
}


/**
 *  const podcasts = await err404(apiClient.getApiRadioPodcastPrograms({  slug: props.params.slug }, {...cache}));
 *     const newest = !isUser ? await err404(apiClient.getApiRadioPodcastNewestEpisode({  slug: props.params.slug }, {...cache})) : undefined;
 */


